const controller = '/config'
export default axios => ({
  getSiteConfig(obj) {
    return axios.get(`${controller}/properlly-style`,obj)
  },
})
